import { Upload } from '@/assets/icons'

/**
 * Icon + label shown wherever a drop target invites the user to drop files to upload.
 */
export function DropFilesToUploadLabel() {
  return (
    <span className="inline-flex items-center gap-2">
      <Upload className="size-5 text-brand-neutral-800" />
      <span className="whitespace-nowrap font-rethink-sans text-base font-semibold leading-6 text-brand-neutral-800">Drop Files to Upload</span>
    </span>
  )
}
